module.exports = __webpack_public_path__ + "static/img/logo.47cd15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/common/logo.png
// module id = +pEW
// module chunks = 0 1 2